export function isDemoEnvironment(hostname: string): boolean {
  return hostname === "demo.sdlabs.atinary.com";
}
